import { Navigate } from 'react-router-dom';

/**
 * Route protetta che verifica l'autenticazione via token in localStorage.
 * @param {string} tokenKey - chiave localStorage del token (es. 'admin_token')
 * @param {string} loginPath - path di redirect se non autenticato
 */
const ProtectedRoute = ({ children, tokenKey = 'admin_token', loginPath = '/login' }) => {
  const isAuthenticated = !!localStorage.getItem(tokenKey);

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
